'use strict';

var React = require('react');

var SvgIconsMajor = function SvgIconsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m10.618 18 3.382-6.764 3.382 6.764h-6.764zm-6.618-2v-6.101a5.006 5.006 0 0 0 5.898-5.899h6.102v6.764l-1.106-2.211c-.339-.678-1.449-.678-1.789 0l-3.723 7.447h-5.382zm15.894 2.553-1.894-3.789v-11.264a1.5 1.5 0 0 0-1.5-1.5h-7.526c-.914-1.207-2.347-2-3.974-2-2.757 0-5 2.243-5 5 0 1.627.793 3.061 2 3.975v7.525a1.5 1.5 0 0 0 1.5 1.5h4.882l-.277.553a1 1 0 0 0 .895 1.447h10a.997.997 0 0 0 .894-1.447z"
  }));
};

exports.SvgIconsMajor = SvgIconsMajor;
